import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mens-beauty-news',
  templateUrl: './mens-beauty-news.component.html',
  styleUrls: ['./mens-beauty-news.component.scss']
})
export class MensBeautyNewsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
